module.exports = __webpack_public_path__ + "6a94675e737c3e9a74c34a602abf6640.pdf";